import { useCallback } from "react"
import { useComputed } from "@preact/signals-react"
import { getSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS } from "@constants"
import { userData } from "@signals"
import { useAdminSkuSavingData } from "./index"
import { adminSkuFormData, adminSkuReadyToLunchSkuForm, adminSkuRowViewedMappings, isLoadingAdminSkuViewMapping } from "../@signals"


export default function useAdminSkuTable(skuID, available=null) {
    const isLoading = useComputed(() => adminSkuReadyToLunchSkuForm.value.includes(skuID))
    const isClicked = useComputed(() => adminSkuRowViewedMappings.value.skuID === skuID)

    const  { getSavingData, updateSavingData } = useAdminSkuSavingData()

    const handleAvailable = useCallback((newValue, rollback) => {
        const { availables } = getSavingData(skuID)

        getSubmit(`${BACKEND_APIS.SKU_DATA}/switch-attribute/${userData.value.customerID}/${skuID}/${available}`).then(() => {
            let isAvailablePricing = availables.available_pricing
            if (available === "available_pricing")
                isAvailablePricing = newValue

            let isAvailableMarketplaces = availables.available_marketplaces
            if (available === "available_marketplaces")
                isAvailableMarketplaces = newValue

            updateSavingData(skuID, {
                availables: { ...availables, [available]: newValue },
                availableToFilters: [
                    ...(isAvailablePricing ? ["Pricing"] : []),
                    ...(isAvailableMarketplaces ? ["Marketplaces"] : [])
                ]
            })
        }).catch(() => rollback())
    }, [skuID, available])

    const handleValidated = useCallback((newValue, rollback) => {
        getSubmit(`${BACKEND_APIS.SKU_DATA}/switch-attribute/${skuID}/validated`).then(() => {
            updateSavingData(skuID, { validated: newValue })
        }).catch(() => rollback())
    }, [skuID])

    const handleClickViewMapping = useCallback(() => {
        const dataRow = getSavingData(skuID)
        adminSkuRowViewedMappings.value = {
            skuID: skuID,
            skuName: dataRow.skuName
        }
    }, [skuID])

    const handleClickEdit = useCallback(() => {
        const dataRow = getSavingData(skuID)
        adminSkuFormData.value = {
            skuID: skuID,
            category: dataRow.categoryID,
            brand: dataRow.brandID,
            brandName: dataRow.brand,
            skuName: dataRow.skuName,
            oldName: dataRow.skuName,
            ean: dataRow.ean,
            imageURL: dataRow.imageURL,
            availablePricing: dataRow.availables.available_pricing,
            availableMarketplaces: dataRow.availables.available_marketplaces,
            validated: dataRow.validated
        }
    }, [skuID])

    return {
        isLoading: isLoading.value,
        isClicked: isClicked.value,
        isLoadingViewMapping: isClicked.value && isLoadingAdminSkuViewMapping.value,

        handleAvailable,
        handleValidated,
        handleClickViewMapping,
        handleClickEdit
    }
}